import API from "../../../../../global/api";


export const requestDashboardData = () => {
    return {
        type: "REQUEST_DASHBOARD_DATA",
    };
};
export const successDashboardData = (data) => {
    return {
        type: "SUCCESS_DASHBOARD_DATA",
        payload: data,
    };
};
export const errorDashboardData = () => {
    return {
        type: "ERROR_DASHBOARD_DATA",
    };
};
export const DashboardDataApi = (data) => {
    return (dispatch) => {
        dispatch(requestDashboardData());
        API.post(`/reports/accounts-dashboard-data`, data).then((res) => {
            let getData = res.data;
            dispatch(successDashboardData(getData));
        }).catch((error) => {
            dispatch(errorDashboardData());
        })
    };
};